import { makeStyles } from "@material-ui/styles";

export const useResyncConfStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },

    paper: {
      padding: theme.spacing(2),
    },
    tableRow: {
      "&:hover": {
        backgroundColor: "#e3e3e3",
      },
      cursor: "pointer",
    },

    tableCell: {
      fontSize: "15px",
      fontWeight: "bold",
    },
    divStyle: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "1em",
    },
    listItemStyle: {
      padding: "5px 5px 5px 0.4em",
    },
    listItemTextStyle: {
      fontSize: "0.813rem",
      fontWeight: "lighter",
    },
    buttonGridStyle: {
      paddingTop: "1em",
      paddingLeft: "8em",
    },
    checkBoxStyle: {
      height: "40em",
      overflow: "auto",
      marginTop: "10px",
    },
    iconStyle: { fontSize: "12px", padding: "0px" },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },

    fieldLabelStyles: {
      paddingBottom: "1em",
      fontWeight: "bold",
    },
    fieldSpace: {
      paddingTop: "3em",
      paddingLeft: "3em",
      paddingRight: "3em",
      paddingBottom: "3em",
    },
    buttonPosition: {
      paddingTop: "2.5em",
    },
    buttonStyle: {
      paddingTop: "3em",
      textAlign: "right",
    },
  })
);
